import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckIcon } from '@heroicons/react/24/outline';

import { DocumentTypeWithVirtual, MessageV2DTO } from 'support/types';
import { SendConfirmationModalFlow } from 'pages/Transactions/components/SendConfirmationModalFlow/SendConfirmationModalFlow';

import { useHandlePendingReview } from '../../../hooks/useHandlePendingReview';
import { ActionConfig } from '../components/types';

export const useMarkAsReviewedAction = (message: MessageV2DTO): ActionConfig => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { handleApprove, isApprovingMessage, isMessageApproved } = useHandlePendingReview({
    reviewId: message.review?.id,
    onCommentChange: () => undefined,
    onEditingChange: () => undefined,
    currentComment: undefined,
    virtualDocumentType: message.type as DocumentTypeWithVirtual,
  });

  const isLoading = isApprovingMessage || isMessageApproved;

  return {
    label: t('transactions:show.actionButtons.review.approve'),
    analyticsId: 'webedi:header-mark-as-reviewed',
    loading: isLoading,
    LeftIcon: CheckIcon,
    onClick: () => setIsModalOpen(true),
    renderModal: (modalMessage: MessageV2DTO) => (
      <SendConfirmationModalFlow
        open={isModalOpen}
        message={modalMessage}
        onSubmit={(annotationIds) => {
          setIsModalOpen(false);
          handleApprove(annotationIds);
        }}
        onCancel={() => setIsModalOpen(false)}
      />
    ),
  };
};
